import ReactPerfectScrollbar from "react-perfect-scrollbar";
export default ReactPerfectScrollbar;
//# sourceMappingURL=CustomScrollArea.js.map